export function FrameSize (pEditor)
{
  const setSizeRefreshTime = [100, 250, 500];

  let cloneEditableAreaCoords,
      editorMinHeight = null,
      isEditorSizeFixed = false,
      oldSize = 0,
      oldSizeIn = 0,
      scrollBarWidth,
      prevIFrameBodyContent,
      isIFrameBodyFixHeight = false,
      isEditorNoScroll = false,
      oldHeightDelta = 0,
      setSizeTM = 0,
      setSizeRefreshTM = 0,
      savedSelection =
      {
        anchorNode: null,
        anchorOffset: null,
        focusNode: null,
        focusOffset: null,
        isCollapsed: null,
        rangeCount: null
      };


  this.init = () =>
  {
    cloneEditableAreaCoords = BEditor.dimensions.getElementBox((pEditor.isGadget ? pEditor.cloneEditableArea : null));
  };


  this.reInit = () =>
  {
    this.stop();

    isEditorSizeFixed = false;
    isEditorNoScroll = false;
  };


  const initSize = (isViewMode) =>
  {
    let inContainerWidth,
        inContainerHeight;

    if (pEditor.editorMinHeight === 0)
    {
      pEditor.editorMinHeight = pEditor.parentContainer.offsetHeight;
    }

    if (isEditorSizeFixed)
    {
      inContainerWidth = pEditor.parentContainer.offsetWidth - cloneEditableAreaCoords.deltaInnerWidth;
      inContainerHeight = pEditor.parentContainer.offsetHeight;
      pEditor.inContainer.style.display = 'none';
      pEditor.objIFrame.style.width = (pEditor.isMultiEditorMode ? '100%' : inContainerWidth + 'px'); //TODO Dime EditorWidth
      pEditor.objIFrame.style.height = inContainerHeight + 'px';
      pEditor.iFrameDoc.body.style.width = inContainerWidth + 'px';
      pEditor.iFrameDoc.body.style.height = '';
      pEditor.iFrameDoc.body.style.cssText += 'height: ' + inContainerHeight + 'px !important';
      pEditor.iFrameDoc.body.style.overflowY = (BEditor.browser.isWebKit && !pEditor.extParameters.omitOverflowY) ? 'visible' : 'hidden';
      pEditor.iFrameDoc.body.scroll = 'no';
      pEditor.cutBox.style.width = (pEditor.isMultiEditorMode ? '' : inContainerWidth + 'px'); //TODO Dime EditorWidth
      pEditor.cutBox.style.height = inContainerHeight + 'px';
      pEditor.cutBox.style.display = 'block';
    }
    else
    {
      scrollBarWidth = BEditor.window.getScrollBarWidth(pEditor.$winContent);

      if (pEditor.content.isInTextArea && pEditor.$Style(pEditor.inContainer, 'display') === 'none')
      {
        inContainerWidth = pEditor.parentContainer.offsetWidth;
        inContainerHeight = pEditor.$StyleInt(pEditor.inContainer, 'height');
      }
      else
      {
        let inContainerOffsetHeight = pEditor.inContainer.offsetHeight;

        inContainerWidth = Math.min(pEditor.inContainer.offsetWidth, pEditor.parentContainer.offsetWidth) - (cloneEditableAreaCoords.deltaInnerWidth);
        inContainerHeight = (!editorMinHeight || inContainerOffsetHeight - cloneEditableAreaCoords.deltaInnerHeight  > editorMinHeight) ? inContainerOffsetHeight - cloneEditableAreaCoords.deltaInnerHeight : editorMinHeight;
        pEditor.inContainer.style.display = 'none';
      }

      inContainerWidth = inContainerWidth || BEditor.styleHelpers.getElementStyleInt(pEditor.inContainer, 'width') || (isViewMode ? 25 : 50);
      inContainerHeight = inContainerHeight || BEditor.styleHelpers.getElementStyleInt(pEditor.inContainer, 'height') || (isViewMode ? 25 : 50);

      pEditor.iFrameDoc.body.style.width = (BEditor.browser.isIE) ? 'auto' : '100%';
      pEditor.iFrameDoc.body.style.height = '';
      pEditor.iFrameDoc.body.style.cssText += 'height: auto !important';
      pEditor.iFrameDoc.body.style.minHeight = (editorMinHeight ? editorMinHeight + 'px' : 0);
      pEditor.cutBox.style.width = (pEditor.isMultiEditorMode ? '' : inContainerWidth + 'px'); //TODO Dime EditorWidth
      pEditor.cutBox.style.height = inContainerHeight + 'px';
      pEditor.objIFrame.style.width = (pEditor.isMultiEditorMode ? '100%' : inContainerWidth + 'px'); //TODO Dime EditorWidth
      pEditor.objIFrame.style.height = inContainerHeight + 'px';
      pEditor.cutBox.style.display = 'block';
    }

    if (pEditor.isGadget)
    {
      pEditor.cloneEditableArea.style.display = '';
    }
  };


  this.start = (isRefresh, isViewMode) =>
  {
    this.stop();

    if (isViewMode != null)
    {
      initSize(isViewMode);
    }

    setSizeTM = setInterval(this.setSize, 11);
    setSizeRefreshTM = setInterval(function () { try { oldSizeIn = 0; } catch (err) {}}, 1000);

    if (isRefresh)
    {
      for (let i = 0; i < setSizeRefreshTime.length; i++)
      {
        setTimeout(function () { try { oldSizeIn = 0; } catch (err) {}}, setSizeRefreshTime[i]);
      }
    }
  };


  this.stop = () =>
  {
    if (setSizeTM) clearInterval(setSizeTM);
    if (setSizeRefreshTM) clearInterval(setSizeRefreshTM);

    setSizeTM = 0;
    setSizeRefreshTM = 0;
  };


  this.setSize = () =>
  {
    let currentSelection,
        lastElement,
        iFrameDocHeight,
        iFrameDocClientHeight,
        newHeight,
        cutBoxCutHeight,
        scrollBarDelta = 0,
        iFrameBodyContent;

    if (!(pEditor.$(pEditor.iFrameId) && pEditor.iFrameDoc && pEditor.iFrameDoc.body))
    {
      pEditor.pThis.dispose();
      pEditor.pThis.isObjStay = true;
      return false;
    }
    else
    {
      try
      {
        currentSelection = pEditor.iFrame.getSelection();

        savedSelection =
        {
          anchorNode: currentSelection.anchorNode,
          anchorOffset: currentSelection.anchorOffset,
          focusNode: currentSelection.focusNode,
          focusOffset: currentSelection.focusOffset,
          isCollapsed: currentSelection.isCollapsed,
          rangeCount: currentSelection.rangeCount
        }
      }
      catch (err) {}

      if (pEditor.isEditorSizeFixed)
      {
        return true;
      }
    }

    if (BEditor.browser.isIE)
    {
      lastElement = pEditor.iFrameDoc.body.lastChild;

      if (!lastElement || lastElement.nodeType !== 1 || !lastElement.getAttribute('data-waielastline'))
      {
        pEditor.helpers.fixers.fixIELastLine();
        return true;
      }

      lastElement.style.display = 'block';
    }

    if (pEditor.iFrameDoc.body.scrollWidth - (BEditor.browser.isIE ? 1 : 0) > pEditor.iFrameDoc.body.clientWidth && !pEditor.isEditorInViewMode)
    {
      scrollBarDelta = scrollBarWidth;
    }

    if (BEditor.browser.isIE)
    {
      iFrameDocHeight = (lastElement.offsetTop + ((lastElement.previousSibling && lastElement.previousSibling.innerHTML != null && lastElement.previousSibling.innerHTML.length === 0 && lastElement.previousSibling.currentStyle['display'].toLowerCase() === 'block') ? 1 : 0));
    }
    else if (BEditor.browser.isEdge)
    {
      iFrameDocHeight = pEditor.iFrameDoc.body.offsetHeight;
      //###WA-39062### iFrameDocHeight = Math.max(pEditor.iFrameHtml.offsetHeight, pEditor.iFrameDoc.body.offsetHeight);
    }
    else if (BEditor.browser.isWebKit)
    {
      iFrameDocHeight = pEditor.iFrameDoc.body.scrollHeight;
      //###WA-39062###iFrameDocHeight = Math.max(pEditor.iFrameHtml.offsetHeight, pEditor.iFrameDoc.body.scrollHeight);
    }
    else
    {
      iFrameDocHeight = pEditor.iFrameDoc.body.scrollHeight;
    }

    if (pEditor.editorMinHeight && iFrameDocHeight < pEditor.editorMinHeight && !pEditor.isEditorInViewMode)
    {
      iFrameDocHeight = pEditor.editorMinHeight;
    }

    //###WA-39062###iFrameDocClientHeight = (BEditor.browser.isWebKit ? Math.max(iFrameDocHeight, pEditor.iFrameHtml.offsetHeight, pEditor.iFrameDoc.body.offsetHeight) : iFrameDocHeight);
    iFrameDocClientHeight = iFrameDocHeight;

    if (!pEditor.isAbsElementMoving)
    {
      newHeight = (oldSize !== iFrameDocHeight || oldSizeIn === iFrameDocClientHeight) ? iFrameDocHeight : ((pEditor.editorMinHeight && iFrameDocClientHeight < pEditor.editorMinHeight && !pEditor.isEditorInViewMode) ? pEditor.editorMinHeight : iFrameDocClientHeight);
      newHeight += scrollBarDelta;

      if (pEditor.objIFrame.offsetHeight !== newHeight + oldHeightDelta || oldSize !== iFrameDocHeight || oldSizeIn !== iFrameDocClientHeight)
      {
        pEditor.objIFrame.style.height = newHeight + 'px';
        pEditor.cutBox.style.height = pEditor.objIFrame.offsetHeight + 'px';
        oldHeightDelta = pEditor.objIFrame.offsetHeight - newHeight;

        if (BEditor.browser.isIE)
        {
          oldSize = lastElement.offsetTop + ((lastElement.previousSibling && lastElement.previousSibling.innerHTML != null && lastElement.previousSibling.innerHTML.length === 0 && lastElement.previousSibling.currentStyle['display'].toLowerCase() === 'block') ? 1 : 0);
        }
        else
        {
          pEditor.iFrame.scrollTo(pEditor.iFrame.scrollX, 0);

          if (pEditor.cutBoxCup)
          {
            let objIFrameOffsetHeight = pEditor.objIFrame.offsetHeight,
                iFrameDocBodyOffsetHeight = pEditor.iFrameDoc.body.offsetHeight;

            if (objIFrameOffsetHeight > iFrameDocBodyOffsetHeight)
            {
              cutBoxCutHeight = objIFrameOffsetHeight - iFrameDocBodyOffsetHeight;

              if (pEditor.iFrameDoc.body.scrollWidth > pEditor.iFrameDoc.body.clientWidth)
              {
                cutBoxCutHeight -= scrollBarDelta - (BEditor.browser.isWebKit ? 1 : 0);
                pEditor.cutBoxCup.style.bottom = scrollBarWidth + 'px';
              }
              else
              {
                pEditor.cutBoxCup.style.bottom = 0;
              }

              pEditor.cutBoxCup.style.height = cutBoxCutHeight + 'px';
            }
            else
            {
              pEditor.cutBoxCup.style.height = 0;
            }

            pEditor.cutBoxCup.style.left = '-3700px';
            pEditor.cutBoxCup.style.width = 0;
            pEditor.cutBoxCup.style.height = 0;
            pEditor.cutBoxCup.style.visibility = 'hidden';
          }

          oldSize = (BEditor.browser.isWebKit ? Math.max(pEditor.iFrameHtml.offsetHeight, pEditor.iFrameDoc.body.scrollHeight, pEditor.editorMinHeight) : pEditor.iFrameDoc.body.scrollHeight);
        }

        oldSizeIn = (BEditor.browser.isWebKit ? Math.max(pEditor.iFrameHtml.offsetHeight, pEditor.iFrameDoc.body.offsetHeight, pEditor.editorMinHeight) : pEditor.iFrameHtml.offsetHeight - (BEditor.browser.isIE ? scrollBarDelta : 0));

        pEditor.pThis.EditorResized.fireHandlers({ 'editingElement': (pEditor.isGadget ? pEditor.cloneEditableArea : pEditor.cutBox) });
      }
    }

    if (pEditor.iFrameDoc.body.innerHTML.length < 30)
    {
      iFrameBodyContent = pEditor.iFrameDoc.body.innerHTML;

      if (iFrameBodyContent !== prevIFrameBodyContent)
      {
        prevIFrameBodyContent = iFrameBodyContent;

        if (iFrameBodyContent.replace(/\s+/g, '') === '')
        {
          pEditor.htmlElement.style.height = '';
          pEditor.htmlElement.style.cssText += 'height: 50px !important';
          pEditor.iFrameDoc.body.style.height = '';
          pEditor.iFrameDoc.body.style.cssText += 'height: 50px !important';
          isIFrameBodyFixHeight = true;
        }
        else
        {
          pEditor.htmlElement.style.height = '';
          pEditor.htmlElement.style.cssText += 'height: auto !important';
          pEditor.iFrameDoc.body.style.height = '';
          pEditor.iFrameDoc.body.style.cssText += 'height: auto !important';
          isIFrameBodyFixHeight = false;
        }
      }
    }
    else if (isIFrameBodyFixHeight)
    {
      pEditor.htmlElement.style.height = '';
      pEditor.htmlElement.style.cssText += 'height: auto !important';
      pEditor.iFrameDoc.body.style.height = '';
      pEditor.iFrameDoc.body.style.cssText += 'height: auto !important';
      isIFrameBodyFixHeight = false;
    }

    if (BEditor.browser.isIE && lastElement)
    {
      lastElement.style.display = 'none';
    }
  };


  this.setEditorFixedHeight = (container) =>
  {
    let areaHeight = container.getAttribute('data-areaHeight');

    if (areaHeight && areaHeight.toLowerCase() !== 'auto')
    {
      let height = parseInt(areaHeight.replace(/[^0-9]/g, ''));

      if (!isNaN(height))
      {
        isEditorSizeFixed = true;

        if (editorMinHeight == null || height > editorMinHeight)
        {
          editorMinHeight = height;
        }
      }
    }
  };


  this.setEditorNoScroll = (container) =>
  {
    let noScroll = container.getAttribute('data-noScroll');

    if (noScroll)
    {
      isEditorNoScroll = true;
    }
  };


  this.setEditorWidth = function(newWidth)
  {
    try
    {
      if (pEditor.iFrameDoc)
      {
        let inContainerWidth = newWidth;
        pEditor.cutBox.style.width = inContainerWidth + 'px';

        if (isEditorSizeFixed)
        {
          pEditor.objIFrame.style.width = inContainerWidth + 'px';
          pEditor.iFrameDoc.body.style.width = inContainerWidth + 'px';
        }
        else
        {
          pEditor.objIFrame.style.width = ((BEditor.browser.isIE) ? inContainerWidth + scrollBarWidth : inContainerWidth) + 'px';
        }
      }
    }
    catch (e) { }
  };


  this.setEditorHeight = function(newHeight)
  {
    try
    {
      if (pEditor.iFrameDoc)
      {
        let inContainerHeight = newHeight;
        pEditor.objIFrame.style.height = inContainerHeight + 'px';
        pEditor.iFrameDoc.body.style.height = '';
        pEditor.iFrameDoc.body.style.cssText += 'height: ' + inContainerHeight + 'px !important';
        pEditor.cutBox.style.height = inContainerHeight + 'px';
      }
    }
    catch (e) { }
  };


  this.dispose = () =>
  {
    this.stop();
  };


  Object.defineProperty(this, 'cloneEditableAreaCoords', { get: () => cloneEditableAreaCoords});
  Object.defineProperty(this, 'isEditorSizeFixed', { get: () => isEditorSizeFixed});
  Object.defineProperty(this, 'isEditorNoScroll', { get: () => isEditorNoScroll});
  Object.defineProperty(this, 'savedSelection', { get: () => savedSelection});
}